import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'
import { attachApiLogger } from '@/shared/apiLogger'

const http = Axios.create({
  baseURL: Env.get('API_HOST'),
  timeout: 30000,
  responseType: 'json'
});

http.defaults.withCredentials = true

http.interceptors.request.use(function(config) {
  const projectUuid = config.headers['X-Project-Uuid'] || localStorage.getItem("current_project_uuid")
  if (projectUuid) {
    config.headers['X-Project-Uuid'] = projectUuid
  }

  const workspaceUuid = config.headers['X-Workspace-Uuid'] || localStorage.getItem("current_workspace_uuid")
  if (workspaceUuid) {
    config.headers['X-Workspace-Uuid'] = workspaceUuid
  }
  
  if (config.headers["X-Project-Env"] === undefined)
    config.headers["X-Project-Env"] = localStorage.getItem("current_env") || "live"

  config.headers["Accept-Language"] = localStorage.getItem("locale") || 'en_US'

  return config
});

// Global flag to prevent multiple rate limit toasts
if (!window._rateLimitToastShown) {
  window._rateLimitToastShown = false;
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 429) {
      // Rate limit error - show toast notification only once
      if (window.vm && window.vm.$bvToast && !window._rateLimitToastShown) {
        window._rateLimitToastShown = true;
        window.vm.$bvToast.toast(window.vm.$t('rateLimitExceeded'), {
          title: window.vm.$t('warning'),
          variant: 'warning',
          solid: true,
          autoHideDelay: 5000
        });
        // Reset flag after toast auto-hides
        setTimeout(() => {
          window._rateLimitToastShown = false;
        }, 5000);
      }
    }
    if (error.response && error.response.status === 403) {
      const message = (error.response.data && error.response.data.message) || window.vm.$t('forbiddenError');
      if (window.vm && window.vm.$bvToast) {
        window.vm.$bvToast.toast(message, {
          title: window.vm.$t('error'),
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
      }
    }
    return Promise.reject(error);
  }
);

attachApiLogger(http, 'API')

export default http